import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Helper } from "../core/util/helper.js";
import {
    ConfigData,
    DocumentService,
    DokumentReference,
} from "./documents";
import { StringKeyDictionary } from "../commonInterfaces.js";

export default class HttpDocumentsService implements DocumentService {
    SaveDocumentRelationship(dokuId: any, type: any, documentKeyVal1: any, documentKeyVal2: any, table: string) {
        return HTTPService.post<JsonResultClass>("Document/SaveDocumentRelationship?Dokuid=" + dokuId + "&type=" + type + "&id=" + documentKeyVal1 + (Helper.hasValue(documentKeyVal2) ? "|" + documentKeyVal2 : "") + (Helper.hasValue(documentKeyVal2) ? "&id2=" + documentKeyVal2 : "") + "&table=" + table)
    }

    SaveDocumentsRelationships(isGuids: string[], type: any, documentKeyVal1: any, documentKeyVal2: any, table: string): Promise<JsonResultClass<any>> {
        return HTTPService.post<JsonResultClass>("Document/SaveDocumentsRelationships", {
            isGuids: isGuids,
            type: type,
            id: documentKeyVal1 + (Helper.hasValue(documentKeyVal2) ? "|" + documentKeyVal2 : ""),
            table: table
        });
    }

    LoadConfig = (type: any, id: any, table: string, readOnly: boolean): Promise<JsonResultClass<ConfigData>> => {
        return HTTPService.get("Document/Index", { type: type, id: id, table: table, readOnly: readOnly });
    }

    GetDocuments = (type: any, documentKeyVal1: any, documentKeyVal2, table: string = null, additionalTypes: DokumentReference[] = null) => {
        return HTTPService.post("Document/GetDocuments", {
            type: type,
            id1: documentKeyVal1,
            id2: documentKeyVal2,
            table: table,
            additionalTypes: additionalTypes
        })
    }

    GetDocumentDetails = (dokuId: any, type: any, refId: number, table: string = null) => {
        return HTTPService.get(`Document/Init?id=${dokuId}&type=${type}&refid=${encodeURIComponent(refId)}&table=${table}`)
    }

    UploadDocument = (formData: FormData) => {
        return HTTPService.post<JsonResultClass>("Document/Upload", formData)
    }

    UploadDocuments = (formData: FormData) => {
        return HTTPService.post<JsonResultClass>("Document/Uploads", formData)
    }

    DeleteRelationShip = (dokuId: any, type: any, documentKeyVal1: any, documentKeyVal2: any, table: string) => {
        return HTTPService.post<JsonResultClass>("Document/DeleteDocumentRelationship?Dokuid=" + dokuId + "&type=" + type + "&id=" + encodeURIComponent(documentKeyVal1) + (Helper.hasValue(documentKeyVal2) ? "|" + documentKeyVal2 : "") + (Helper.hasValue(documentKeyVal2) ? "&id2=" + documentKeyVal2 : "") + "&table=" + table)
    }

    InitHyperlink = (url: string, type: any, refId: any, table: string = null) => {
        return HTTPService.get<JsonResultClass>("Document/InitHyperLink?Url=" + encodeURIComponent(url) + "&type=" + encodeURIComponent(type) + "&id=" + encodeURIComponent(refId) + "&table=" + table)
    }

    DeleteDocument = (dokuId: any, type: any, refId: any) => {
        return HTTPService.get("Document/Delete", { id: dokuId, type: type, refid: refId })
    }

    DocumentExists = (type: any, documentKeyVal1: any, documentKeyVal2: any, fileName) => {
        const sendData: StringKeyDictionary<any> = {
            type: type,
            id: documentKeyVal1 + (Helper.hasValue(documentKeyVal2) ? "|" + documentKeyVal2 : ""),
            name: fileName
        };
        return HTTPService.get("Document/DocumentExists", sendData);
    }

    DocumentsExists = (type: any, documentKeyVal1: any, documentKeyVal2: any, fileNames: string[]) => {
        const id = documentKeyVal1 + (Helper.hasValue(documentKeyVal2) ? "|" + documentKeyVal2 : "");
        return HTTPService.get("Document/DocumensExists", {type: type, id: id, names: fileNames});
    } 

    CheckIfReferencesExists = (isGuid: string) => {
        return HTTPService.get<JsonResultClass<boolean>>("Document/CheckIfReferencesExists?id=" + isGuid);
    }

    GetRights = () => {
        return null;
    }
}